import type { Carate, Rate } from 'lumen/models';
import type { PeriodRate } from 'lumen/models/period';

export function compsetDifference(ownRate: number, median: number): number {
  return median > 0 ? Math.round(((ownRate - median) / median) * 100) / 100 : 0;
}

/**
 * Returns a color class for a rate depending on the difference of the own rate compared to the compset
 * The classes used are ['sold-out', 'green', 'orange', 'red']
 * @param {Number} compsetDifferencePercentage  Number between 0-1. The difference of the own rate with the median compset
 * @param {Number} lowerLimit                   Number between 0-1. The upper limit percentage. If the compsetDifference is below or equal, rate is green
 * @param {Number} upperLimit                   Number between 0-1. The upper limit percentage. If the compsetDifference is above or equal, rate is red
 * @param {Object} ownRate                      Optional parameter rate object.
 */
export function compsetDifferenceBackground(
  compsetDifferencePercentage: number,
  lowerLimit: number | null,
  upperLimit: number | null,
  ownRate: PeriodRate | Rate | Carate | null | undefined,
): 'sold-out' | 'green' | 'orange' | 'red' {
  const lowerLimitPercentage = lowerLimit !== null ? lowerLimit / 100 : 0;
  const upperLimitPercentage = upperLimit !== null ? upperLimit / 100 : 0.1;

  // Default color is sold-out, unless a value was found
  if (
    (ownRate && ownRate.value === 0) ||
    ownRate === null ||
    ownRate === undefined
  ) {
    return 'sold-out'; // Return soldout for 0 value rates if it was passed into this util
  }

  // Determine color by limits
  if (compsetDifferencePercentage <= lowerLimitPercentage) {
    return 'green';
  }

  if (compsetDifferencePercentage <= upperLimitPercentage) {
    return 'orange';
  }

  return 'red';
}
